import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHighlighter24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconHighlighter24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m16.468 4.645 2.91 2.911a.5.5 0 0 1 .029.677l-6.948 8.197-4.865-4.865 8.197-6.947a.5.5 0 0 1 .677.027m-9.67 8.245-1.061 2.825 2.572 2.572 2.825-1.06zm8.023-9.417a2 2 0 0 1 2.708.112l2.91 2.91a2 2 0 0 1 .112 2.708l-7.235 8.535a2 2 0 0 1-.822.58l-3.959 1.487a1 1 0 0 1-.898-.099l-.943.868a1.75 1.75 0 0 1-1.185.462H3.998c-1.574 0-2.348-1.916-1.216-3.01l1.604-1.547a1 1 0 0 1-.167-.99l1.488-3.959a2 2 0 0 1 .579-.822zm-9.378 14.07 1.117 1.116-.882.81a.25.25 0 0 1-.169.067H3.998a.25.25 0 0 1-.174-.43zM14.75 19.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHighlighter24);
